import { type FC } from "react"
import { Accordion, Title, Text, Paper } from "@mantine/core"
import { IconCaretDownFilled } from "@tabler/icons-react"
import classes from "./TermsAndConditionsAccordion.module.css"

interface TermsAndConditionsAccordionProps {
	header?: string
	content?: string
	onAccordionClick?: () => void
}

export const TermsAndConditionsAccordion: FC<
	TermsAndConditionsAccordionProps
> = ({ header, content, onAccordionClick }) => {
	if (!header && !content) {
		return null
	}

	return (
		<Paper className={classes.root} p={0} radius={8} withBorder={false}>
			<Accordion
				variant="default"
				chevronPosition="left"
				chevron={
					<IconCaretDownFilled
						className={classes.chevronIcon}
						color="var(--text-color-primary)"
						aria-hidden
					/>
				}
				classNames={{
					item: classes.item,
					control: classes.control,
					panel: classes.panel,
					content: classes.content,
					chevron: classes.chevron,
					label: classes.label
				}}
			>
				<Accordion.Item value="terms">
					<Accordion.Control onClick={onAccordionClick}>
						<Title
							variant="title-gradient"
							fz={{ base: 20, sm: 28 }}
							fw={600}
							className={classes.title}
							m={0}
						>
							{header}
						</Title>
					</Accordion.Control>
					<Accordion.Panel>
						<Text className={classes.body} maw="100%">
							{content}
						</Text>
					</Accordion.Panel>
				</Accordion.Item>
			</Accordion>
		</Paper>
	)
}
